import '../css/landing.css';

import img from '../assets/WhatsApp Image 2025-03-17 at 20.00.35_27fb9e79.jpg'
import { useNavigate } from 'react-router-dom';

export default function Landing() {
    const navigate = useNavigate();
    return(
        <div className="landing">
                <span className="left">
                    <div className="caption1">
                        <hr />
                        <h4>WE ARE BHUMIHAR MANCH BANGALORE</h4>
                    </div>
                    <div className="titles">
                        <div className="caption2">
                            <p>At <span>BMB,</span> we work towards the betterment of our <span>Community</span> </p>
                        </div>
                        <div className="caption3">
                            <p>Bhumihar Manch Bangalore (BMB) was established with sole objective to integrate and to associate with members of Bhumihar Brahmin Samaj also popularly known as Bhavan , traditionally a land owner from Bihar , Jharkhand , Uttar Pradesh , Madhya Pradesh & in some part of Nepal and now staying in bangalore. Bumihar Manch Bangalore (BMB) strives to carry forward the rich cultural legacy, providing a platform to connect with member’s family, enjoy and feel the nostalgia of bond and togetherness. </p>
                        </div>
                        <div className="btns">
                            <a href='/about'>
                            <button type="button" className="btn btn-outline-info">Know More</button>
                            </a>
                        </div>
                    </div>

                </span>
                <span className="right">
                    <img src={img} alt="Smiling Faces" />
                </span>
            </div>
    );
}